<template>
  <div>
    <v-card
      flat
      outlined
      style="border: 3px solid #18cae6"
      class="ma-auto"
      light
    >
      <v-card-title class="ma-auto">
        <span class="headline">
          CLIENT
          <span class="red--text">FORM</span>
        </span>
        <v-spacer></v-spacer>
        <v-expand-transition>
          <div class="red--text">
            <span>{{ appMessage }}</span>
            <v-btn
              v-if="appMessage"
              @click="clearAppMessage"
              small
              text
              rounded
              outlined
              >close</v-btn
            >
          </div>
        </v-expand-transition>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-form class="ma-2 pa-2" @submit.prevent="saveAndContinue" ref="form">
        <div>
          <v-card
            style="border-radius: 26px; border: 1px solid #a07800"
            outlined
            tile
            rounded
            class="ma-auto"
            dense
            light
          >
            <v-form @submit.prevent="onContinue">
              <v-container fluid v-if="!continueForm">
                <v-row>
                  <v-radio-group
                    v-model="type"
                    row
                    label="WHAT TYPE OF ENTITY ARE YOU"
                    class="ma-auto text-center"
                  >
                    <v-radio
                      class="ma-auto"
                      label="Individual"
                      value="individual"
                    ></v-radio>
                    <v-radio
                      class="ma-auto"
                      label="Business"
                      value="business"
                    ></v-radio>
                  </v-radio-group>
                </v-row>

                <v-expand-transition>
                  <div v-if="type == 'individual'">
                    <v-text-field
                      v-model="firstName"
                      label="FIRST NAME"
                      color="#a07800"
                      autofocus
                      style="max-width: 500px"
                      class="ma-auto"
                      clearable
                      outlined
                    ></v-text-field>
                    <v-text-field
                      v-model="lastName"
                      label="LAST NAME"
                      color="#a07800"
                      style="max-width: 500px"
                      class="ma-auto"
                      clearable
                      outlined
                    ></v-text-field>
                  </div>
                </v-expand-transition>
                <v-expand-transition>
                  <v-text-field
                    v-if="type == 'business'"
                    v-model="fullName"
                    label="FULL BUSINESS NAME"
                    color="#a07800"
                    autofocus
                    style="max-width: 500px"
                    class="ma-auto"
                    clearable
                    outlined
                  ></v-text-field>
                </v-expand-transition>
                <v-text-field
                  v-model="email"
                  label="EMAIL:"
                  color="#a07800"
                  style="max-width: 500px"
                  class="ma-auto"
                ></v-text-field>
                <v-text-field
                  v-model="phone"
                  label="PASSWORD:"
                  color="#a07800"
                  style="max-width: 500px"
                  class="ma-auto"
                ></v-text-field>
                <div class="text-center">
                  <v-btn
                    oulined
                    rounded
                    color="green"
                    :disabled="!phone"
                    type="submit"
                    >CONITNUE</v-btn
                  >
                </div>
              </v-container>
            </v-form>

            <div class="ma-3">
              <v-progress-circular
                class="text-center ma-auto"
                indeterminate
                size="64"
                v-if="overlay"
              ></v-progress-circular>

              <div class="ma-auto" v-if="continueForm">
                <!-- <div v-if="preMadeForm"> -->
                <div v-if="preMadeFormQuestions">
                  <div v-if="formTitle">
                    <v-card-text light class="text-center headline ma-3">
                      {{ formTitle }}
                    </v-card-text>
                  </div>
                  <div v-if="instructions" class="ma-3">
                    <v-expand-transition>
                      <div v-if="showInstructions">
                        <v-card-text
                          class="text-center headline red--text ma-3"
                          style="text-decoration: underline"
                          >INSTRUCTIONS</v-card-text
                        >

                        <div
                          v-for="(inst, index) in instructions"
                          :key="index"
                          class="ma-3 text-justify"
                        >
                          <p class="title text-justify">{{ inst }}</p>
                        </div>
                      </div>
                    </v-expand-transition>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        small
                        rounded
                        outlined
                        v-if="showInstructions"
                        @click="showInstructions = false"
                        >HIDE INSTRUCTIONS</v-btn
                      >
                      <v-btn
                        small
                        rounded
                        outlined
                        v-if="!showInstructions"
                        @click="showInstructions = true"
                        >SHOW INSTRUCTIONS</v-btn
                      >
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </div>
                  <v-card
                    style="
                      border-radius: 26px;
                      width: auto;
                      border: 1px solid #a07800;
                      min-height: 550px;
                    "
                    light
                  >
                    <v-card-title
                      class="display-1 font-weight-regular justify-space-between text-center"
                    >
                      <v-spacer></v-spacer>
                      <div class="text-center">
                        {{ windowStep }}/{{ windowSteps }}
                      </div>
                      <v-spacer></v-spacer>
                    </v-card-title>
                    <v-card-actions>
                      <v-btn
                        :disabled="windowStep === 1"
                        dark
                        @click="windowStep--"
                        large
                        color="red"
                        rounded
                        >Back</v-btn
                      >
                      <v-spacer></v-spacer>

                      <v-btn
                        :disabled="windowStep === windowSteps"
                        color="primary"
                        depressed
                        @click="saveAndContinue"
                        rounded
                        dark
                        large
                        >Next</v-btn
                      >
                    </v-card-actions>
                    <hr
                      size="1px"
                      color="#18CAE6"
                      style="width: 75%"
                      class="ml-auto mr-auto mt-3 mb-3"
                    />

                    <!-- THIS IS WHERE ALL THE MAGIC HAPPENS -->

                    <v-window
                      v-model="windowStep"
                      style="overflow-x: scroll"
                      continuous
                    >
                      <div v-for="(q, i) in preMadeFormQuestions" :key="i">
                        <v-window-item :value="i + 1">
                          <v-card-text v-if="q.type === 'date'">
                            <div class="ma-4 title font-weight-regular">
                              {{ q.text }}
                            </div>
                            <v-textarea
                              label="Place Your Response Here"
                              v-model="q.response"
                              color="primary"
                              style="max-width: 700px"
                              auto-grow
                              class="ma-2"
                              outlined
                              hint="DD/MM/YYYY"
                              clearable
                            ></v-textarea>
                          </v-card-text>
                          <v-card-text
                            v-if="q.type === 'address'"
                            class="ma-auto"
                          >
                            <div class="ma-4 title font-weight-regular">
                              {{ q.text }}
                            </div>

                            <v-text-field
                              color="primary"
                              style="max-width: 500px"
                              class="ma-2"
                              outlined
                              label="Place Your Response Here"
                              v-model="q.response"
                              clearable
                            ></v-text-field>
                          </v-card-text>
                          <v-card-text v-if="q.type === 'textArea'">
                            <div class="ma-4 title font-weight-regular">
                              {{ q.text }}
                            </div>

                            <v-textarea
                              auto-grow
                              color="primary"
                              style="max-width: 700px"
                              class="ma-2"
                              outlined
                              label="Place Your Response Here"
                              v-model="q.response"
                              clearable
                            ></v-textarea>
                          </v-card-text>
                          <v-card-text v-if="q.type === 'listOfNames'">
                            <div class="ma-4 title font-weight-regular">
                              {{ q.text }}
                            </div>
                            <v-textarea
                              label="Place Your Response Here"
                              v-model="tempListItem"
                              color="primary"
                              style="max-width: 500px"
                              class="ma-2"
                              outlined
                              hint="CLICK THE ADD BUTTON TO ADD TO LIST"
                              clearable
                            ></v-textarea>
                            <v-layout>
                              <v-btn
                                :disabled="!tempListItem"
                                rounded
                                color="green"
                                @click="addResponseToList(i)"
                              >
                                <v-icon>mdi-plus</v-icon>ADD
                              </v-btn>
                              <v-spacer></v-spacer>
                            </v-layout>

                            <v-layout column class="ma-2">
                              <div class="ma-2 text-center title">
                                Current List
                              </div>
                              <div
                                class="ma-2 text-center subtitle-1"
                                v-for="(r, index) in q.response"
                                :key="index"
                              >
                                {{ index + 1 }} - {{ r }}
                                <v-btn
                                  class="ma-2"
                                  rounded
                                  outlined
                                  color="red"
                                  small
                                  @click="removeResponseFromList(i, index)"
                                  >remove</v-btn
                                >
                              </div>
                            </v-layout>
                          </v-card-text>
                          <v-card-text v-if="q.type === 'dependantBoolTrue'">
                            <div class="ma-4 title font-weight-regular">
                              {{ q.text }}
                            </div>
                            <v-radio-group v-model="q.response">
                              <v-radio label="YES" value="true"></v-radio>
                              <v-radio
                                label="NO"
                                value="false"
                                @click="clearDependantQuestionResponse(i)"
                              ></v-radio>
                            </v-radio-group>
                            <v-expand-transition>
                              <div v-if="q.response === 'true'">
                                <div class="ma-4 title font-weight-regular">
                                  {{ q.dependantQuestion.text }}
                                </div>
                                <div
                                  v-if="q.dependantQuestion.type === 'textArea'"
                                >
                                  <v-textarea
                                    color="primary"
                                    style="max-width: 700px"
                                    auto-grow
                                    class="ma-2"
                                    outlined
                                    label="Place Your Response Here"
                                    v-model="q.dependantQuestion.response"
                                    clearable
                                  ></v-textarea>
                                </div>
                                <div
                                  v-if="
                                    q.dependantQuestion.type ===
                                      'subListOfNames'
                                  "
                                >
                                  <v-textarea
                                    label="Place Your Response Here"
                                    v-model="tempListItem"
                                    color="primary"
                                    style="max-width: 500px"
                                    class="ma-2"
                                    outlined
                                    hint="CLICK THE ADD BUTTON TO ADD TO LIST"
                                    clearable
                                  ></v-textarea>
                                  <v-layout>
                                    <v-btn
                                      :disabled="!tempListItem"
                                      rounded
                                      color="green"
                                      @click="addResponseToList(i)"
                                    >
                                      <v-icon>mdi-plus</v-icon>ADD
                                    </v-btn>
                                    <v-spacer></v-spacer>
                                  </v-layout>

                                  <v-layout column class="ma-2">
                                    <div class="ma-2 text-center title">
                                      Current List
                                    </div>
                                    <div
                                      class="ma-2 text-center subtitle-1"
                                      v-for="(r, index) in q.dependantQuestion
                                        .response"
                                      :key="index"
                                    >
                                      {{ index + 1 }} - {{ r }}
                                      <v-btn
                                        class="ma-2"
                                        rounded
                                        outlined
                                        color="red"
                                        small
                                        @click="
                                          removeResponseFromList(i, index)
                                        "
                                        >remove</v-btn
                                      >
                                    </div>
                                  </v-layout>
                                </div>
                                <div
                                  v-if="
                                    q.dependantQuestion.type ===
                                      'optionsExclusiveBool'
                                  "
                                >
                                  <v-radio-group
                                    v-model="q.dependantQuestion.response"
                                  >
                                    <v-radio label="YES" value="true"></v-radio>
                                    <v-radio
                                      label="NO"
                                      value="false"
                                      @click="
                                        clearDependantSubQuestionResponse(i)
                                      "
                                    ></v-radio>
                                  </v-radio-group>
                                  <v-expand-transition>
                                    <div
                                      v-if="
                                        q.dependantQuestion.response === 'true'
                                      "
                                    >
                                      <v-radio-group
                                        v-model="
                                          q.dependantQuestion.optionResponse
                                        "
                                      >
                                        <div
                                          v-for="(option, index) in q
                                            .dependantQuestion.options"
                                          :key="index"
                                        >
                                          <v-radio
                                            :label="option"
                                            :value="option"
                                          ></v-radio>
                                        </div>
                                      </v-radio-group>
                                      <div
                                        v-if="
                                          q.dependantQuestion
                                            .subDependantQuestion
                                        "
                                      >
                                        <div
                                          class="ma-4 title font-weight-regular"
                                        >
                                          {{
                                            q.dependantQuestion
                                              .subDependantQuestion.text
                                          }}
                                        </div>
                                        <div
                                          v-if="
                                            q.dependantQuestion
                                              .subDependantQuestion.type ===
                                              'subListOfNames'
                                          "
                                        >
                                          <v-textarea
                                            label="Place Your Response Here"
                                            v-model="tempListItem"
                                            color="primary"
                                            style="max-width: 500px"
                                            class="ma-2"
                                            outlined
                                            hint="CLICK THE ADD BUTTON TO ADD TO LIST"
                                            clearable
                                          ></v-textarea>
                                          <v-layout>
                                            <v-btn
                                              :disabled="!tempListItem"
                                              rounded
                                              color="green"
                                              @click="
                                                addSubDependantResponseToList(i)
                                              "
                                            >
                                              <v-icon>mdi-plus</v-icon>ADD
                                            </v-btn>
                                            <v-spacer></v-spacer>
                                          </v-layout>

                                          <v-layout column class="ma-2">
                                            <div class="ma-2 text-center title">
                                              Current List
                                            </div>
                                            <div
                                              class="ma-2 text-center subtitle-1"
                                              v-for="(r, index) in q
                                                .dependantQuestion
                                                .subDependantQuestion.response"
                                              :key="index"
                                            >
                                              {{ index + 1 }} - {{ r }}
                                              <v-btn
                                                class="ma-2"
                                                rounded
                                                outlined
                                                color="red"
                                                small
                                                @click="
                                                  removeSubDependantResponseFromList(
                                                    i,
                                                    index
                                                  )
                                                "
                                                >remove</v-btn
                                              >
                                            </div>
                                          </v-layout>
                                        </div>
                                      </div>
                                    </div>
                                  </v-expand-transition>
                                </div>
                              </div>
                            </v-expand-transition>
                          </v-card-text>

                          <v-card-text v-if="q.type === 'dependantBoolFalse'">
                            <div class="ma-4 title font-weight-regular">
                              {{ q.text }}
                            </div>
                            <v-radio-group v-model="q.response">
                              <v-radio label="YES" value="true"></v-radio>
                              <v-radio
                                label="NO"
                                value="false"
                                @click="clearDependantQuestionResponse(i)"
                              ></v-radio>
                            </v-radio-group>
                            <v-expand-transition>
                              <div v-if="q.response === 'false'">
                                <div class="ma-4 title font-weight-regular">
                                  {{ q.dependantQuestion.text }}
                                </div>
                                <div
                                  v-if="q.dependantQuestion.type === 'textArea'"
                                >
                                  <v-textarea
                                    color="primary"
                                    style="max-width: 700px"
                                    auto-grow
                                    class="ma-2"
                                    outlined
                                    label="Place Your Response Here"
                                    v-model="q.dependantQuestion.response"
                                    clearable
                                  ></v-textarea>
                                </div>
                                <div
                                  v-if="
                                    q.dependantQuestion.type ===
                                      'subListOfNames'
                                  "
                                >
                                  <v-textarea
                                    label="Place Your Response Here"
                                    v-model="tempListItem"
                                    color="primary"
                                    style="max-width: 500px"
                                    class="ma-2"
                                    outlined
                                    hint="CLICK THE ADD BUTTON TO ADD TO LIST"
                                    clearable
                                  ></v-textarea>
                                  <v-layout>
                                    <v-btn
                                      :disabled="!tempListItem"
                                      rounded
                                      color="green"
                                      @click="addResponseToList(i)"
                                    >
                                      <v-icon>mdi-plus</v-icon>ADD
                                    </v-btn>
                                    <v-spacer></v-spacer>
                                  </v-layout>

                                  <v-layout column class="ma-2">
                                    <div class="ma-2 text-center title">
                                      Current List
                                    </div>
                                    <div
                                      class="ma-2 text-center subtitle-1"
                                      v-for="(r, index) in q.dependantQuestion
                                        .response"
                                      :key="index"
                                    >
                                      {{ index + 1 }} - {{ r }}
                                      <v-btn
                                        class="ma-2"
                                        rounded
                                        outlined
                                        color="red"
                                        small
                                        @click="
                                          removeResponseFromList(i, index)
                                        "
                                        >remove</v-btn
                                      >
                                    </div>
                                  </v-layout>
                                </div>
                                <div
                                  v-if="
                                    q.dependantQuestion.type ===
                                      'optionsExclusiveBool'
                                  "
                                >
                                  <v-radio-group
                                    v-model="q.dependantQuestion.response"
                                  >
                                    <v-radio label="YES" value="true"></v-radio>
                                    <v-radio
                                      label="NO"
                                      value="false"
                                      @click="
                                        clearDependantSubQuestionResponse(i)
                                      "
                                    ></v-radio>
                                  </v-radio-group>
                                  <v-expand-transition>
                                    <div
                                      v-if="
                                        q.dependantQuestion.response === 'true'
                                      "
                                    >
                                      <v-radio-group
                                        v-model="
                                          q.dependantQuestion.optionResponse
                                        "
                                      >
                                        <div
                                          v-for="(option, index) in q
                                            .dependantQuestion.options"
                                          :key="index"
                                        >
                                          <v-radio
                                            :label="option"
                                            :value="option"
                                          ></v-radio>
                                        </div>
                                      </v-radio-group>
                                      <div
                                        v-if="
                                          q.dependantQuestion
                                            .subDependantQuestion
                                        "
                                      >
                                        <div
                                          class="ma-4 title font-weight-regular"
                                        >
                                          {{
                                            q.dependantQuestion
                                              .subDependantQuestion.text
                                          }}
                                        </div>
                                        <div
                                          v-if="
                                            q.dependantQuestion
                                              .subDependantQuestion.type ===
                                              'subListOfNames'
                                          "
                                        >
                                          <v-textarea
                                            label="Place Your Response Here"
                                            v-model="tempListItem"
                                            color="primary"
                                            style="max-width: 500px"
                                            class="ma-2"
                                            outlined
                                            hint="CLICK THE ADD BUTTON TO ADD TO LIST"
                                            clearable
                                          ></v-textarea>
                                          <v-layout>
                                            <v-btn
                                              :disabled="!tempListItem"
                                              rounded
                                              color="green"
                                              @click="
                                                addSubDependantResponseToList(i)
                                              "
                                            >
                                              <v-icon>mdi-plus</v-icon>ADD
                                            </v-btn>
                                            <v-spacer></v-spacer>
                                          </v-layout>

                                          <v-layout column class="ma-2">
                                            <div class="ma-2 text-center title">
                                              Current List
                                            </div>
                                            <div
                                              class="ma-2 text-center subtitle-1"
                                              v-for="(r, index) in q
                                                .dependantQuestion
                                                .subDependantQuestion.response"
                                              :key="index"
                                            >
                                              {{ index + 1 }} - {{ r }}
                                              <v-btn
                                                class="ma-2"
                                                rounded
                                                outlined
                                                color="red"
                                                small
                                                @click="
                                                  removeSubDependantResponseFromList(
                                                    i,
                                                    index
                                                  )
                                                "
                                                >remove</v-btn
                                              >
                                            </div>
                                          </v-layout>
                                        </div>
                                      </div>
                                    </div>
                                  </v-expand-transition>
                                </div>
                              </div>
                            </v-expand-transition>
                          </v-card-text>

                          <v-card-text
                            v-if="q.type === 'boolDependantSetMultipleAnswer'"
                          >
                            <div class="ma-4 title font-weight-regular">
                              {{ q.text }}
                            </div>
                            <v-radio-group v-model="q.response">
                              <v-radio label="YES" value="true"></v-radio>
                              <v-radio
                                label="NO"
                                value="false"
                                @click="clearDependantSetResponse(i)"
                              ></v-radio>
                            </v-radio-group>
                            <div v-if="q.response === 'true'">
                              <div
                                v-for="(dq, index) in q.dependantSet"
                                :key="index"
                              >
                                <div class="ma-4 title font-weight-regular">
                                  {{ dq.text }}
                                </div>
                                <div v-if="dq.type === 'textArea'">
                                  <v-textarea
                                    color="primary"
                                    style="max-width: 700px"
                                    class="ma-2"
                                    outlined
                                    label="Place Your Response Here"
                                    v-model="tempSetResponses[`${dq.model}`]"
                                    clearable
                                    auto-grow
                                  ></v-textarea>
                                </div>

                                <div v-if="dq.type === 'textField'">
                                  <v-text-field
                                    color="primary"
                                    style="max-width: 500px"
                                    class="ma-2"
                                    outlined
                                    label="Place Your Response Here"
                                    v-model="tempSetResponses[`${dq.model}`]"
                                    clearable
                                  ></v-text-field>
                                </div>
                                <div v-if="dq.type === 'boolDependantSet'">
                                  <v-radio-group
                                    v-model="tempSetResponses[`${dq.model}`]"
                                  >
                                    <v-radio label="YES" value="true"></v-radio>
                                    <v-radio
                                      label="NO"
                                      value="false"
                                      @click="
                                        clearSubDependantSetResponse(i, index)
                                      "
                                    ></v-radio>
                                  </v-radio-group>
                                  <div
                                    v-if="
                                      tempSetResponses[`${dq.model}`] === 'true'
                                    "
                                  >
                                    <div
                                      v-for="(subDQ, index) in dq.dependantSet"
                                      :key="index"
                                    >
                                      <div
                                        class="ma-4 title font-weight-regular"
                                      >
                                        {{ subDQ.text }}
                                      </div>
                                      <div v-if="subDQ.type === 'textArea'">
                                        <v-textarea
                                          color="primary"
                                          style="max-width: 700px"
                                          class="ma-2"
                                          outlined
                                          label="Place Your Response Here"
                                          v-model="
                                            tempSetResponses[`${subDQ.model}`]
                                          "
                                          clearable
                                          auto-grow
                                        ></v-textarea>
                                      </div>
                                      <div v-if="subDQ.type === 'textField'">
                                        <v-text-field
                                          color="primary"
                                          style="max-width: 500px"
                                          class="ma-2"
                                          outlined
                                          label="Place Your Response Here"
                                          v-model="
                                            tempSetResponses[`${subDQ.model}`]
                                          "
                                          clearable
                                        ></v-text-field>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <v-btn
                              @click="addDependantSetResponse(i)"
                              color="green"
                              rounded
                              >ADD</v-btn
                            >
                            <v-layout column class="ma-2">
                              <div class="ma-2 text-center title">
                                Current List
                              </div>
                              <div
                                class="ma-2 text-center subtitle-1"
                                v-for="(r, index) in preMadeFormQuestions[i]
                                  .setResponses"
                                :key="index"
                              >
                                {{ index + 1 }} - {{ r }}
                                <v-btn
                                  class="ma-2"
                                  rounded
                                  outlined
                                  color="red"
                                  small
                                  @click="removeSetResponse(i, index)"
                                  >remove</v-btn
                                >
                              </div>
                            </v-layout>
                          </v-card-text>
                          <v-card-text v-if="q.type === 'boolDependantSet'">
                            <div class="ma-4 title font-weight-regular">
                              {{ q.text }}
                            </div>
                            <v-radio-group v-model="q.response">
                              <v-radio label="YES" value="true"></v-radio>
                              <v-radio
                                label="NO"
                                value="false"
                                @click="clearDependantSetResponse(i)"
                              ></v-radio>
                            </v-radio-group>
                            <div v-if="q.response === 'true'">
                              <div
                                v-for="(dq, index) in q.dependantSet"
                                :key="index"
                              >
                                <div class="ma-4 title font-weight-regular">
                                  {{ dq.text }}
                                </div>
                                <div v-if="dq.type === 'textArea'">
                                  <v-textarea
                                    color="primary"
                                    style="max-width: 700px"
                                    class="ma-2"
                                    outlined
                                    label="Place Your Response Here"
                                    v-model="dq.response"
                                    clearable
                                    auto-grow
                                  ></v-textarea>
                                </div>

                                <div v-if="dq.type === 'textField'">
                                  <v-text-field
                                    color="primary"
                                    style="max-width: 500px"
                                    class="ma-2"
                                    outlined
                                    label="Place Your Response Here"
                                    v-model="dq.response"
                                    clearable
                                  ></v-text-field>
                                </div>
                                <div v-if="dq.type === 'boolDependantSet'">
                                  <v-radio-group v-model="dq.response">
                                    <v-radio label="YES" value="true"></v-radio>
                                    <v-radio
                                      label="NO"
                                      value="false"
                                      @click="
                                        clearSubDependantSetResponse(i, index)
                                      "
                                    ></v-radio>
                                  </v-radio-group>
                                  <div v-if="dq.response === 'true'">
                                    <div
                                      v-for="(subDQ, index) in dq.dependantSet"
                                      :key="index"
                                    >
                                      <div
                                        class="ma-4 title font-weight-regular"
                                      >
                                        {{ subDQ.text }}
                                      </div>
                                      <div v-if="subDQ.type === 'textArea'">
                                        <v-textarea
                                          color="primary"
                                          style="max-width: 700px"
                                          class="ma-2"
                                          outlined
                                          label="Place Your Response Here"
                                          v-model="subDQ.response"
                                          clearable
                                          auto-grow
                                        ></v-textarea>
                                      </div>
                                      <div v-if="subDQ.type === 'textField'">
                                        <v-text-field
                                          color="primary"
                                          style="max-width: 500px"
                                          class="ma-2"
                                          outlined
                                          label="Place Your Response Here"
                                          v-model="subDQ.response"
                                          clearable
                                        ></v-text-field>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </v-card-text>
                          <v-card-text v-if="q.type === 'clientSignature'">
                            <div class="ma-4 title font-weight-regular">
                              {{ q.text }}
                            </div>
                            <div class="text-center">
                              <v-btn
                                class="ma-auto"
                                v-if="!autoSign"
                                large
                                @click="toggleAutoSign"
                                >TYPE YOUR SIGNATURE</v-btn
                              >
                              <v-btn
                                class="ma-auto"
                                v-if="autoSign"
                                large
                                @click="toggleAutoSign"
                                >SIGN WITH BOX</v-btn
                              >
                            </div>
                            <div v-if="!autoSign">
                              <v-expand-transition>
                                <VueSignaturePad
                                  width="500px"
                                  height="200px"
                                  ref="signaturePad"
                                  style="
                                    border: 1px solid blue;
                                    background-color: white;
                                  "
                                  class="ma-auto"
                                />
                              </v-expand-transition>
                            </div>
                            <v-expand-transition>
                              <div v-if="autoSign" class="text-center ma-auto">
                                <div class="text-center">
                                  <v-layout row>
                                    <v-spacer></v-spacer>
                                    <v-text-field
                                      color="primary"
                                      style="max-width: 500px"
                                      outlined
                                      label="Type Your Name"
                                      v-model="textSignature"
                                      clearable
                                      class="ma-auto"
                                    ></v-text-field>
                                    <v-btn large @click="saveTextSignature(i)"
                                      >ACCEPT</v-btn
                                    >
                                    <v-spacer></v-spacer>
                                  </v-layout>
                                </div>
                              </div>
                            </v-expand-transition>
                            <div class="text-center">
                              <v-btn @click="undo" :disabled="autoSign"
                                >Undo</v-btn
                              >
                              <v-btn @click="save(i)" :disabled="autoSign"
                                >Save Signature</v-btn
                              >
                            </div>
                            <v-btn
                              v-if="!autoSign"
                              :disabled="!signature"
                              large
                              rounded
                              color="green"
                              @click="onSaveFormResponses"
                              >Save Responses</v-btn
                            >
                            <v-btn
                              v-if="autoSign"
                              :disabled="!textSignature"
                              large
                              rounded
                              color="green"
                              @click="onSaveFormResponses"
                              >Save Responses</v-btn
                            >
                            <div v-if="lastResponse" class="text-center">
                              LAST RESPONSE: {{ lastResponse }}
                            </div>
                          </v-card-text>
                        </v-window-item>
                      </div>
                    </v-window>
                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-btn
                        :disabled="windowStep === 1"
                        dark
                        @click="windowStep--"
                        large
                        color="red"
                        rounded
                        >Back</v-btn
                      >
                      <v-spacer></v-spacer>
                      <v-btn
                        :disabled="windowStep === windowSteps"
                        color="primary"
                        depressed
                        @click="saveAndContinue"
                        rounded
                        dark
                        large
                        >Next</v-btn
                      >
                    </v-card-actions>
                    <hr
                      size="1px"
                      color="#18CAE6"
                      style="width: 75%"
                      class="ml-auto mr-auto mt-3 mb-3"
                    />
                    <div class="ma-2">
                      <div
                        class="title font-weight-regular text-center"
                        v-if="!showDocs"
                        @click="showDocs = true"
                      >
                        click here to upload documents
                      </div>
                      <div
                        class="title font-weight-regular text-center"
                        v-if="showDocs"
                        @click="showDocs = false"
                      >
                        click here to hide documents
                      </div>
                    </div>

                    <hr
                      size="1px"
                      color="#18CAE6"
                      style="width: 75%"
                      class="ml-auto mr-auto mt-3 mb-3"
                    />
                    <v-expand-transition v-if="showDocs">
                      <v-layout row>
                        <div style="width: 45%">
                          <div
                            v-for="(category, index) in documentCategories"
                            :key="index"
                          >
                            <template>
                              <div>
                                <app-doc-uploader-dialog
                                  :category="category"
                                  :firm_slug="firmSlug"
                                  :matter_slug="matterSlug"
                                  :client_slug="clientSlug"
                                ></app-doc-uploader-dialog>
                              </div>
                            </template>
                          </div>
                        </div>
                        <v-divider vertical></v-divider>
                        <div style="width: 50%">
                          <div v-for="(doc, i) in user.clientDocs" :key="i">
                            <div class="ma-2">
                              {{ doc.name }} -
                              <span
                                v-if="doc.category === 'personalInformation'"
                                class="ma-4 font-weight-regular text-center"
                                >CATEGORY: PERSONAL</span
                              >
                              <span
                                v-if="doc.category === 'generalInformation'"
                                class="ma-4 font-weight-regular text-center"
                                >CATEGORY: GENERAL</span
                              >
                              <span
                                v-if="doc.category === 'damages'"
                                class="ma-4 font-weight-regular text-center"
                                >CATEGORY: DAMAGES</span
                              >
                              <span
                                v-if="doc.category === 'miscellaneous'"
                                class="ma-4 font-weight-regular text-center"
                                >CATEGORY: MISCELLANEOUS</span
                              >
                            </div>
                            <v-btn
                              rounded
                              outlined
                              color="red"
                              small
                              @click="removeClientDocument(doc, i)"
                            >
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </div>
                        </div>
                      </v-layout>
                    </v-expand-transition>
                  </v-card>
                </div>
              </div>

              <v-card-actions>
                <v-btn
                  v-if="!autoSign"
                  :disabled="!signature"
                  large
                  rounded
                  color="green"
                  @click="onSaveFormResponses"
                  >Save Responses</v-btn
                >
                <v-btn
                  v-if="autoSign"
                  :disabled="!textSignature"
                  large
                  rounded
                  color="green"
                  @click="onSaveFormResponses"
                  >Save Responses</v-btn
                >
                <div v-if="lastResponse" class="text-center">
                  LAST RESPONSE: {{ lastResponse }}
                </div>
              </v-card-actions>
            </div>
            <!-- </div> -->
          </v-card>
        </div>
        <v-layout row class="mt-2">
          <v-spacer></v-spacer>
        </v-layout>
      </v-form>
    </v-card>
  </div>
</template>

<script>
/**
 *
 *
 * this component is very complicated needs to be simplified significantly...
 *
 * this component is located at the /clients route
 * the contents of this component are completely determined by the link that the client has clicked
 * If the client is authenticated already, there will be a "user" value the component gets the data required from the route
 * If a firm user is visiting the link and already has an account signed in as an "admin" type user
 * the user will have to log out an dlog back in as the client
 * client type users are created immediately when a plaintiff is created in the database
 * the user's email and phone number are username and password
 *
 * the first part of this component asks whether the client that is visiting the form
 * is an individual or a business
 * then it asks for name, email and phone numnber
 * this has to be input EXACLTY for the clien to be able to see the form
 *
 * when the signin is complete a watcher on the "user" object is triggered
 * the watcher goes and grabs the form definition object saved to the database when the firm user sent it to the client.
 * the form determines the following:
 *
 * 1. the form definition object determines how each question is displaid and how answers are taken from the client
 *  for example some questions are simple boolian and some are super complex multi answer milti dependency questions
 * 2. The number of steps are determined by the form definition object
 * 3. The document categories that are shown to the client for them to upload are determined by the form definition object
 *
 *
 * //todo: must add a piece that will read a custom set of questions that are creaeted by the firm User
 *
 *
 *
 */
import { mask } from "vue-the-mask";
import slugify from "slugify";
import * as firebase from "firebase";
import * as moment from "moment";
import VueSignaturePad from "vue-signature-pad";

export default {
  directives: {
    mask
  },
  name: "PartyForm",
  components: {
    VueSignaturePad
  },
  // props: ["matter", "user"],
  data() {
    return {
      // message: null,
      lastResponse: null,
      textSignature: null,
      autoSign: false,
      overlay: false,
      showDocs: false,
      dialog: false,
      signature: null,
      e1: 0,
      windowStep: 1,
      firstName: null,
      lastName: null,
      fullName: null,
      email: null,
      phone: null,
      phoneMask: "(###) ###-####",
      dateMask: "##/##/####",
      // continueForm: false,
      minor: false,
      guardian: null,
      message: null,
      info: null,
      type: null,
      alias: null,
      personal: null,
      capacity: null,
      insured: null,
      treated: false,
      injuries: [],
      owner: null,
      rent: null,
      //general background
      presentAddress: {
        addressLine1: null,
        city: null,
        state: null,
        zip: null
      },
      employer: {
        name: null,
        addressLine1: null,
        city: null,
        state: null,
        zip: null,
        duties: null,
        jobTitle: null
      },
      ownerOfRealProperty: false,
      renter: false,
      businessOwner: false,
      //insurance
      insurance: {
        insured: false,
        insurerName: null,
        policyNumber: null,
        policyLimit: null
      },
      //property Damage
      property: {
        addressLine1: null,
        city: null,
        state: null,
        zip: null,
        damages: []
      },
      incomeLoss: [],
      preMadeFormQuestions: null,
      instructions: null,
      formTitle: null,
      windowSteps: null,
      showInstructions: false,
      tempListItem: null,
      tempArray: null,
      tempSetResponses: {},
      documentCategories: null,
      reloaded: false,
      formId: null
    };
  },
  computed: {
    // obsolete??
    clientFormList() {
      return this.$store.getters.clientFormList;
    },
    //shows errors
    appMessage() {
      return this.$store.getters.appMessage;
    },
    //used to get user data and form definitiion
    clientSlug() {
      return this.$route.params.client;
    },
    //used to get firm infomraiton from database
    firmSlug() {
      return this.$route.params.firm;
    },
    //used to get matter information from the database - this might be a security concern
    matterSlug() {
      return this.$route.params.matter;
    },
    //gets user object from store - probably obsolete
    user() {
      return this.$store.getters.user;
    },
    //probably obsolete
    firm() {
      return this.$store.getters.firm;
    },
    //this is reserved for custom forms created by firm (or "admin" type) users
    //still need to work on this
    questions() {
      return this.user.formDef.questions;
    },
    //migth be obsolete
    preMadeForm() {
      return this.user.formDef.preMadeForm;
    },
    //the authentication token includes the the role/type of user
    //if this is a client role user the form will show
    //this role feature will be used extensively as more user types are defined such as "process-server"
    role() {
      return this.$store.getters.role;
    },
    //this is the step that must pass for the user to see the form
    continueForm() {
      if (this.user && this.role === "client") {
        return true;
      } else {
        return false;
      }
    },
    // steps() {
    //   // return this.user.stepCount;
    //   return this.user.formDef.questions.length;
    // },

    //this might be obsolete
    currentTitle() {
      switch (this.windowStep) {
        // this.windowStep.forEach(step =>{
        case this.windowStep:
          return this.preMadeFormQuestions[this.windowStep - 1].text;
        // })

        // case 2: return 'Create a password'
        default:
          return "Done";
      }
    }
  },
  watch: {
    // steps(val) {
    //   if (this.e1 > val) {
    //     this.e1 = val;
    //   }
    // },

    //experimental and are not included in the component
    //remnants of prior iterations that I have kept because I might want to explore this
    //apporoach
    personal(val) {
      if (val === "yes") {
        this.capacity = "in his/her personal capacity";
      }
    },
    //experimental and are not included in the component
    //remnants of prior iterations that I have kept because I might want to explore this
    //apporoach
    insured(val) {
      if (val === "true") {
        this.insurance.insured = true;
      }
    },
    //experimental and are not included in the component
    //remnants of prior iterations that I have kept because I might want to explore this
    //apporoach
    owner(val) {
      if (val === "true") {
        this.ownerOfRealProperty = true;
      }
    },
    //experimental and are not included in the component
    //remnants of prior iterations that I have kept because I might want to explore this
    //apporoach
    type(val) {
      if (val == "business") {
        this.businessOwner = true;
      }
    },
    //experimental and are not included in the component
    //remnants of prior iterations that I have kept because I might want to explore this
    //apporoach
    rent(val) {
      if (val == "true") {
        this.renter = true;
      }
    },
    //experimental and are not included in the component
    //remnants of prior iterations that I have kept because I might want to explore this
    //apporoach
    capacity(val) {
      if (val == "as guardian ad litem") {
        this.minor = true;
      }
    },
    //when user value changes
    user(val) {
      console.log("user from watch", val);
      console.log("partyType from watch", val.partyType);

      //set the questions to be the responses in the formlist item based on the id in the route

      // const getForm = firebase.functions().httpsCallable("getForm");
      ///////////////////////////////////////////////////////////////////////////////////////
      //this is a loading spinenr
      this.overlay = true;
      if (val !== null && val !== undefined) {
        //set up listener
        //get reference to db location
        let formRef = firebase
          .firestore()
          // .collection("firms")
          // .doc(this.$route.params.firm)
          .collection("matters")
          .doc(this.$route.params.matter)
          .collection("clients")
          .doc(this.$route.params.client)
          .collection("formList")
          .doc(this.$route.params.id);
        //get the form definition object
        formRef
          .get()
          .then(res => {
            console.log("response: ", res.data());
            let form = res.data();
            this.formTitle = form.name;
            this.preMadeFormQuestions = form.responses;
            this.lastResponse = form.responseDate;
            this.formId = form.id;
            this.windowSteps = form.windowSteps;
            this.documentCategories = form.documentCategories;
            this.instructions = form.instructions;
            this.overlay = false;
          })
          .then(() => {
            //create an activity object
            let activity = {
              content: `${
                this.email
              } -  ${this.fullName.toUpperCase()} signed in to fill out ${
                this.formTitle
              } for  ${this.$route.params.matter}.`,
              matterID: this.$route.params.matter,
              date: moment().format("MMMM Do YYYY, h:mm:ss a"),
              user: this.user
            };
            let firmSlug = this.$route.params.firm;
            let matterSlug = this.$route.params.matter;
            let payload = {
              activity,
              firmSlug,
              matterSlug
            };
            //add the activity to the fimr document and the matter document
            this.$store.dispatch("addFirmActivity", payload);
            this.$store.dispatch("addMatterActivity", payload);
          })
          .catch(e => {
            console.log(e);
            //commmit("setAppMessage", e.message);
          });

        //this is experimental
        // formRef.onSnapshot(res => {
        // const changes = res.docChanges();
        // console.log(changes);
        // changes.forEach(change => {
        //   if (change.type === "added") {
        //     const matter = change.doc.data();
        //     //if matter.sharedWith includes payload.user
        //     // if (matter.sharedWith.includes(payload.user)) {
        //     // console.log("included", payload.user);
        //     // commit("setMatter", matter);
        //     // } else {
        //     //   console.log("not included", payload.user);
        //     // }
        //     // commit("setMatter", matter);
        //   } else if (change.type === "modified") {
        //     const modifiedMatter = change.doc.data();
        //     //if matter.sharedWith includes payload.user
        //     // if (modifiedMatter.sharedWith.includes(payload.user)) {
        //     commit("modifyMatter", modifiedMatter);
        //     // }
        //     // commit("modifyMatter", modifiedMatter);
        //   } else if (change.type === "removed") {
        //     const removedMatter = change.doc.data();
        //     commit("removeMatter", removedMatter);
        //   }
        // });
        // });
      }
    }
  },
  methods: {
    clearAppMessage() {
      this.$store.dispatch("setAppMessage", null);
    },
    toggleAutoSign() {
      this.textSignature = null;
      this.autoSign = !this.autoSign;
    },
    //fired every time the "NEXT" button is clicked by the user
    saveAndContinue() {
      let formRef = firebase
        .firestore()
        // .collection("firms")
        // .doc(this.$route.params.firm)
        .collection("matters")
        .doc(this.$route.params.matter)
        .collection("clients")
        .doc(this.$route.params.client)
        .collection("formList")
        .doc(this.$route.params.id);

      // the same form that was received from teh database and set to this.preMadeFormQuestions
      //is edited in the form builder above
      //then saved to the database replacing the one that was there, every time someone hits the "NEXT" button
      formRef
        .update({
          responses: this.preMadeFormQuestions,
          responseDate: moment().format("MMMM Do YYYY, h:mm:ss a")
        })
        .then(res => {
          console.log("saved changes to form responses response: ", res);
          this.lastResponse = moment().format("MMMM Do YYYY, h:mm:ss a");
          this.windowStep++;
          // this.preMadeFormQuestions = res.responses;
          // this.lastResponse = res.responseDate;
        })
        .catch(e => {
          console.log(e);
        });
    },
    logType() {
      console.log(this.type);
      console.log("user", this.user);
      console.log("responselist", this.preMadeFormQuestions);
    },

    /**
     *
     *
     * the methods below allow the form builder to work
     * these methods work in tandem with the template above to help the
     * user to add and remove items in lists
     *
     * BUT IT NEEDS WORK
     * for example right now you cant edit an existing list item once you have added it to the response
     * when a question can have a list of answers
     * you currently have to remove the one you just created and add a new one
     *
     */
    removeResponseFromList(i, index) {
      console.log(i);
      if (this.preMadeFormQuestions[i].dependantQuestion) {
        this.preMadeFormQuestions[i].dependantQuestion.response.splice(
          index,
          1
        );
      } else {
        this.preMadeFormQuestions[i].response.splice(index, 1);
      }
    },
    addResponseToList(i) {
      if (this.preMadeFormQuestions[i].dependantQuestion) {
        this.preMadeFormQuestions[i].dependantQuestion.response.push(
          this.tempListItem
        );
        this.tempListItem = null;
      } else {
        this.preMadeFormQuestions[i].response.push(this.tempListItem);
        this.tempListItem = null;
      }
      console.log("responselist", this.preMadeFormQuestions);
      console.log("tempListItem", this.tempListItem);
    },
    addSubDependantResponseToList(i) {
      this.preMadeFormQuestions[
        i
      ].dependantQuestion.subDependantQuestion.response.push(this.tempListItem);
      this.tempListItem = null;
    },
    addDependantSetResponse(i) {
      this.preMadeFormQuestions[i].setResponses.push(this.tempSetResponses);
      console.log("responses", this.preMadeFormQuestions);
      this.tempSetResponses = {};
      window.scrollTo({
        top: 100,
        left: 100,
        behavior: "smooth"
      });
    },
    removeSubDependantResponseFromList(i, index) {
      this.preMadeFormQuestions[
        i
      ].dependantQuestion.subDependantQuestion.response.splice(index, 1);
    },
    clearDependantQuestionResponse(i) {
      this.preMadeFormQuestions[i].response = "false";
      this.preMadeFormQuestions[i].dependantQuestion.response = [];
    },
    clearDependantSetResponse(i) {
      this.preMadeFormQuestions[i].response = "false";
    },
    clearSubDependantSetResponse(i, index) {
      this.preMadeFormQuestions[i].dependantSet[index].response = "false";
    },
    clearDependantSubQuestionResponse(i) {
      this.preMadeFormQuestions[i].dependantQuestion.response = "false";
      this.preMadeFormQuestions[
        i
      ].dependantQuestion.subDependantQuestion.response = [];
    },
    removeSetResponse(i, index) {
      this.preMadeFormQuestions[i].setResponses.splice(index, 1);
    },
    addToDialogResponse(i) {
      let value = { ...this.preMadeFormQuestions[i].dialogQuestions };
      this.preMadeFormQuestions[i].response.push(value);
    },
    logResponses() {
      console.log("from log responses", this.preMadeFormQuestions);
    },
    undo() {
      this.$refs.signaturePad[0].undoSignature();
    },
    //saves the users's signature if they chose to apply a wet signature to the signature pad
    save(i) {
      if (!this.autoSign) {
        const { isEmpty, data } = this.$refs.signaturePad[0].saveSignature();
        if (!isEmpty) {
          this.signature = data;
          // if (this.user.formDef.preMadeForm) {
          this.preMadeFormQuestions[i].response = data;
          // }
        }
      }
    },
    //in case the user decides to agree by typing their full name
    saveTextSignature(i) {
      if (this.textSignature !== null && this.textSignature !== undefined) {
        this.preMadeFormQuestions[i].response = {
          signature: this.textSignature
        };
      } else {
        alert("YOU MUST EITHER SIGN OR TYPE YOUR SIGNATURE");
      }
    },
    //obsolete?
    nextStep(n) {
      // console.log("n from next step", n);
      // console.log("e1 from data", this.e1);
      let stepCount = parseInt(this.user.stepCount);
      if (n === stepCount) {
        this.e1 = 1;
      } else {
        this.e1 = n + 1;
      }
    },
    //fired every time "SAVE FORM RESPONSES" button is hit
    onSaveFormResponses() {
      let formRef = firebase
        .firestore()
        // .collection("firms")
        // .doc(this.$route.params.firm)
        .collection("matters")
        .doc(this.$route.params.matter)
        .collection("clients")
        .doc(this.$route.params.client)
        .collection("formList")
        .doc(this.$route.params.id);

      formRef
        .update({
          responses: this.preMadeFormQuestions,
          responseDate: moment().format("MMMM Do YYYY, h:mm:ss a")
        })
        .then(res => {
          console.log("saved changes to form responses response: ", res);
          this.windowStep++;

          this.lastResponse = moment().format("MMMM Do YYYY, h:mm:ss a");
          firebase
            .firestore()
            // .collection("firms")
            // .doc(this.$route.params.firm)
            .collection("matters")
            .doc(this.$route.params.matter)
            .collection("clients")
            .doc(this.$route.params.client)
            .update({
              messages: firebase.firestore.FieldValue.arrayUnion({
                responseDate: this.lastResponse,
                message: `${this.user.fullName} has responded to ${
                  this.formTitle
                } at ${moment().format("MMMM Do YYYY, h:mm:ss a")}`
              })
            })
            .then(() => {
              console.log("added messages");
            })
            .catch(e => {
              console.log(e);
            });
        })
        .catch(e => {
          console.log(e);
        });
    },
    //this method removes the document that the client has already uploaded and saved to storage
    removeClientDocument(doc, i) {
      console.log("removing this document", doc);
      console.log("document index", i);
      firebase
        .firestore()
        // .collection("firms")
        // .doc(this.$route.params.firm)
        .collection("matters")
        .doc(this.$route.params.matter)
        .collection("clients")
        .doc(this.$route.params.client)
        .update({
          clientDocs: firebase.firestore.FieldValue.arrayRemove(doc)
        })
        .then(() => {
          let ref = firebase
            .storage()
            // client/${this.user.firmSlug}/${this.matter.matterSlug}/${this.responses.partySlug}
            // .ref(`${this.$route.path}/${doc.category}/${doc.name}`);
            .ref(
              `client/${this.$route.params.firm}/${this.$route.params.matter}/${this.$route.params.client}/${doc.category}/${doc.name}`
            );
          ref
            .delete()
            .then(() => {
              // this.user.clientDocs.splice(1, i)
              let payload = {
                firm: this.$route.params.firm,
                matter: this.$route.params.matter,
                client: this.$route.params.client
              };
              this.$store.dispatch("autoLoginClient", payload);
            })
            .catch(e => console.log(e));
        })
        .catch(e => console.log(e));
    },
    //this is the first step that the client user have to input their information
    //this function logs the client user in using the same action item in store as teh regular "SingIn" component
    onContinue() {
      if (this.type == "individual") {
        this.alias =
          this.firstName.trim() + " " + this.lastName.trim() + " " + this.phone;
      } else if (this.type == "business") {
        this.alias = this.fullName.trim() + " " + this.phone.trim();
      }
      if (this.fullName == null) {
        this.fullName = this.firstName.trim() + " " + this.lastName.trim();
      }
      //if business

      let partySlug = slugify(this.alias, {
        replacement: "-",
        remove: /[$*_+~.()'"!\-:@,]/g,
        lower: true
      });
      console.log(
        "partySlug from PartyForm inside onContinue function",
        partySlug
      );
      //this would be too many activities
      // let activity = {
      //   content: `${this.email} -  ${this.fullName.toUpperCase()} signed in to fill out ${this.formTitle} for  ${this.$route.params.matter}.`,
      //   matterID: this.$route.params.matter,
      //   date: moment().format("MMMM Do YYYY, h:mm:ss a"),
      //   user: this.user
      // };
      this.$store.dispatch("signUserIn", {
        email: this.email.trim(),
        password: this.phone.trim(),
        firm: this.$route.params.firm,
        matter: this.$route.params.matter,
        client: this.$route.params.client,
        insurance: this.insurance,
        property: this.property,
        firstName: this.firstName,
        lastName: this.lastName,
        phone: this.phone,
        fullName: this.fullName,
        partyType: this.type
        // activity
      });
    }
  },
  created() {
    console.log("this.$route", this.$route);
    console.log("this.$route.params", this.$route.params);
    console.log("this.$route.path", this.$route.path);
    console.log("firm:", this.firm);
  }
};
</script>

<style lang="scss" scoped></style>
